import VastsDistributionChart from "@/components/statistics/VastsDistributionChart";
import { usePageTitle } from "@/components/common/AppShell";

export default function StatisticsPage() {
  usePageTitle("Statistics");
  return (
    <section className="flex min-w-0 flex-col">
      <div className="mb-[26px] flex flex-wrap items-start justify-between gap-4">
        <p className="text-[13.5px] text-(--text-muted)">
          Visualize performance trends and export detailed reports.
        </p>
      </div>

      <VastsDistributionChart />
    </section>
  );
}
